/**
 * Resolves a user-facing message from API / HttpClient error payloads.
 */
export function getApiErrorMessage(error: unknown, fallback = ''): string {
  if (!error || typeof error !== 'object') {
    return fallback;
  }

  const err = error as Record<string, unknown>;
  const body = err['error'];

  if (body && typeof body === 'object') {
    const apiBody = body as Record<string, unknown>;
    const topLevelMessage = apiBody['message'];
    if (typeof topLevelMessage === 'string' && topLevelMessage.trim()) {
      return topLevelMessage;
    }

    const nested = apiBody['error'];
    if (nested && typeof nested === 'object') {
      const nestedMessage = (nested as Record<string, unknown>)['message'];
      if (typeof nestedMessage === 'string' && nestedMessage.trim()) {
        return nestedMessage;
      }
    }
  }

  const directMessage = err['message'];
  if (typeof directMessage === 'string' && directMessage.trim()) {
    return directMessage;
  }

  return fallback;
}
